<div class="p-d-flex">
    <div style="flex-grow: 1">
        <div class="p-grid">
            <div class="p-col-12">
                <p-menubar >
                    <ng-template pTemplate="start" style="width: 100%;">
                        <h2 style="display: inline;">{{selectedChannel}}</h2>
                        <span class="p-mr-2 group-by-wrapper">
                            <button icon="pi pi-tags" pButton pRipple type="button"
                                class="p-button-secondary p-button-text" (click)="groupby.toggle($event);showGroupBy()"
                                pTooltip="Group by" tooltipPosition="top">
                            </button>
                            <span *ngIf="selectedGroupByValue" class="group-by-badge"></span>
                        </span>
                        <app-filters [listCols]="filterCols" [saveFilterData]="saveFilterData"
                            (applyFiltersColumns)="applyFilters($event)"></app-filters>
                    </ng-template>
                </p-menubar>
            </div>

            <p-overlayPanel #groupby [showCloseIcon]="true" [style]="{width: '300px'}">
                <ng-template pTemplate>
                    <p class="p-mb-2">Group By</p>
                    <p-dropdown [options]="enabledListCols" class="panelDD" [filter]="true" styleClass="w-100"
                        [(ngModel)]="selectedGroupBy" optionLabel="header" appendTo="body" placeholder="Select Field">
                    </p-dropdown>
                    <p class="p-mb-2 p-mt-2">Summary Value</p>
                    <p-dropdown [options]="aggregateTypes" class="panelDD" styleClass="w-100"  [filter]="true" optionLabel="type"
                        [(ngModel)]="selectedAggregateTypeBy" [disabled]="!selectedGroupBy"  appendTo="body" placeholder="Select Value Type">
                    </p-dropdown>
                    <div class="p-text-right p-mt-2">
                        <p-button label="Reset" class="p-button-secondary p-mt-2 p-mr-2"
                            (click)="resetGroup();groupby.hide()" [disabled]="!selectedGroupBy || !selectedAggregateTypeBy"></p-button>
                        <p-button label="Apply" class="p-mt-2" (onClick)="applyGroup();groupby.hide()"
                            [disabled]="!selectedGroupBy || !selectedAggregateTypeBy"></p-button>
                    </div>
                </ng-template>
            </p-overlayPanel>
            <ng-container >
                <div class="p-col-12 p-lg-12">
                    <div class="card">
                        <p-table [value]="data" responsiveLayout="scroll"
                            [columns]="cols" [lazy]="true" [paginator]="true" [totalRecords]="totalRecord" [rows]="pageSize"
                            [showCurrentPageReport]="true" [first]="first" [rowsPerPageOptions]="rowsPerPage"
                            styleClass="p-datatable-gridlines floatthead"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                             (onPage)="getData($event)" >
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th id="groupBy" *ngIf="selectedGroupByValue"
                                        style="border-right: 1px solid var(--primary-color);" pResizableColumn
                                        pResizableColumn>Group: {{ selectedGroupByValue?.header }}</th>
                                    <ng-container *ngFor="let col of columns">
                                        <th id="header"
                                            *ngIf="col.checked && col.show && (col.field!=selectedGroupBy?.field)"
                                            style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                            {{col.header}}
                                        </th>
                                    </ng-container>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr class="parentRow" *ngIf="selectedGroupByValue">
                                    <td colspan="30" style="border-right: 1px solid var(--primary-color);">
                                        <span class="p-ml-1">
                                            ({{rowData.groupByValue}})
                                        </span>
                                    </td>
                                </tr>
                                <ng-container *ngIf="selectedGroupByValue">
                                    <tr *ngFor="let s of rowData.list" [pSelectableRow]="s">
                                        <td></td>
                                        <ng-container *ngFor="let col of columns; let i=index;">
                                            <td *ngIf="col.checked && col.show && (col.field!=selectedGroupBy?.field)"
                                                style="white-space: break-spaces;word-break: break-all;">
                                                <ng-container [ngSwitch]="col.dataType">
                                                    <ng-container *ngSwitchCase="'DatePicker'">
                                                        {{s[col.field] | date: 'MM/dd/yyyy'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'Decimal' || 'Number'">
                                                       {{s[col.field]}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'Currency'">
                                                        {{s[col.field] | currencySymbol}}
                                                     </ng-container>
                                                     <ng-container *ngSwitchCase="'Percentage'">
                                                        {{s[col.field] }}<span *ngIf="s[col.field]">%</span>
                                                     </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        {{s[col.field]}}
                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <!-- selectedGroupByValue -->
                                    <tr *ngIf="selectedGroupByValue">
                                        <td>
                                            <strong>Grand_{{selectedAggregateTypeByValue?.type}}</strong>
                                        </td>
                                        <ng-container *ngFor="let col of cols; let i=index;">
                                            <td *ngIf="col.checked && col.show && col.field!=selectedGroupBy?.field">
                                                <ng-container *ngIf="col.dataType=='Currency'">
                                                    <span *ngIf="selectedAggregateTypeByValue?.code=='Sum'">{{ rowData.numericSumMap?.[col.field] | currencySymbol:'number2dp'}}</span>
                                                    <span *ngIf="selectedAggregateTypeByValue?.code=='Avg'">{{ rowData.numericAvgMap?.[col.field] | currencySymbol:'number2dp'}}</span>
                                                </ng-container>
                                                <ng-container *ngIf="(col.dataType=='Number' ||  col.dataType=='Decimal')">
                                                    <span *ngIf="selectedAggregateTypeByValue?.code=='Sum'">{{ rowData.numericSumMap?.[col.field] }}</span>
                                                    <span *ngIf="selectedAggregateTypeByValue?.code=='Avg'">{{ rowData.numericAvgMap?.[col.field] }}</span>
                                                </ng-container>
                                                <ng-container *ngIf="col.dataType=='Percentage'">
                                                    <span *ngIf="selectedAggregateTypeByValue?.code=='Sum'">{{ rowData.numericSumMap?.[col.field] }}%</span>
                                                    <span *ngIf="selectedAggregateTypeByValue?.code=='Avg'">{{ rowData.numericAvgMap?.[col.field] }}%</span>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <tr style="margin-bottom: 5px;">
                                        <td colspan="30" class="no-padding">
                                            <p-paginator styleClass="child-paginator"
                                                (onPageChange)="getChildData($event,rowData)"
                                                [showCurrentPageReport]="true"
                                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                [first]="(rowData.pageNumber-1)" [rows]="rowData.pageSize"
                                                [totalRecords]="rowData.totalNumberOfRows">
                                            </p-paginator>
                                        </td>
                                    </tr>

                                    <!--group list end-->
                                </ng-container>
                                <tr [pSelectableRow]="rowData"
                                    *ngIf="!selectedGroupByValue">
                                    <ng-container *ngFor="let col of columns">
                                        <td *ngIf="col.checked && col.show">
                                            <ng-container [ngSwitch]="col.dataType">
                                                <ng-container *ngSwitchCase="'DatePicker'">
                                                    {{rowData[col.field] | date: 'MM/dd/yyyy'}}
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'Percentage'">
                                                    {{rowData[col.field]}}<span *ngIf="rowData[col.field]">%</span>
                                                 </ng-container>
                                                 <ng-container *ngSwitchCase="'Currency'">
                                                    {{rowData[col.field] | currencySymbol }}
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    {{rowData[col.field]}}
                                                </ng-container>
                                            </ng-container>
                                        </td>
                                    </ng-container>
                                </tr>
                            </ng-template>

                            <!-- selectedGroupByValue -->
                            <ng-template pTemplate="footer" let-columns>
                                <tr *ngIf="selectedGroupByValue">
                                    <td>
                                        <strong>Grand_{{selectedAggregateTypeByValue?.type}}</strong>
                                    </td>
                                    <ng-container *ngFor="let col of columns; let i=index;">
                                        <td *ngIf="col.checked && col.show && col.field!=selectedGroupBy?.field">
                                            <ng-container *ngIf="col.dataType=='Currency'">
                                                <span *ngIf="selectedAggregateTypeByValue?.code=='Sum'">{{ reportTotalRowSum?.[col.field] | currencySymbol:'number2dp'}}</span>
                                                <span *ngIf="selectedAggregateTypeByValue?.code=='Avg'">{{ reportTotalRowAvg?.[col.field] | currencySymbol:'number2dp'}}</span>
                                            </ng-container>
                                            <ng-container *ngIf="(col.dataType=='Number' ||  col.dataType=='Decimal')">
                                                <span *ngIf="selectedAggregateTypeByValue?.code=='Sum'">{{ reportTotalRowSum?.[col.field] }}</span>
                                                <span *ngIf="selectedAggregateTypeByValue?.code=='Avg'">{{ reportTotalRowAvg?.[col.field] }}</span>
                                            </ng-container>
                                            <ng-container *ngIf="col.dataType=='Percentage'">
                                                <span *ngIf="selectedAggregateTypeByValue?.code=='Sum'">{{ reportTotalRowSum?.[col.field] }}%</span>
                                                <span *ngIf="selectedAggregateTypeByValue?.code=='Avg'">{{ reportTotalRowAvg?.[col.field] }}%</span>
                                            </ng-container>
                                        </td>
                                    </ng-container>
                                </tr>
                            </ng-template>


                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td class="p-text-center" [attr.colspan]="activeCols.length">No SerialNo. data
                                        found.</td>
                                </tr>
                            </ng-template> 
                        </p-table>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
